/** FAB button (rest/hover/open), FAB zone, hide-widget chevron, and pending auth pulse. */
export const FAB_CSS = `
    .pw-fab-zone {
      position: absolute; bottom: 16px; right: 0;
      width: 68px; height: 68px; 
      pointer-events: auto;
    }
    .pw-root.pw-recording .pw-fab-zone {
      z-index: 40;
    }

    .pw-fab {
      position: absolute; bottom: 26px; right: 7px;
      width: 54px; height: 54px; border-radius: 9999px;
      border: 1.2px solid transparent;
      background:
        var(--pw-fill-panel) padding-box,
        linear-gradient(transparent, transparent) padding-box,
        var(--pw-border-gradient) border-box;
      box-shadow: var(--pw-shadow-fab-rest);
      display: flex; align-items: center; justify-content: center;
      cursor: pointer; outline: none;
      transition: box-shadow 0.18s ease,
                  opacity 0.25s ease, transform 0.2s ease;
      z-index: 30; pointer-events: auto;
      padding: 0;
    }
    .pw-fab:hover {
      background:
        var(--pw-gradient-overlay) padding-box, 
        var(--pw-fill-button) padding-box, 
        var(--pw-border-gradient) border-box;
      box-shadow: var(--pw-shadow-hover);
    }
    .pw-fab.open {
      background:
        var(--pw-fill-panel) padding-box,
        linear-gradient(transparent, transparent) padding-box,
        var(--pw-border-gradient) border-box;
      box-shadow: var(--pw-shadow-fab-rest);
    }
    .pw-fab.open:hover {
      background:
        var(--pw-gradient-overlay) padding-box, 
        var(--pw-fill-button) padding-box, 
        var(--pw-border-gradient) border-box;
      box-shadow: var(--pw-shadow-fab-rest);
    }
    .pw-fab-pearl, .pw-fab-x {
      position: absolute; inset: 0;
      display: flex; align-items: center; justify-content: center;
      transition: opacity 0.22s ease, transform 0.22s ease;
    }
    .pw-fab-pearl svg, .pw-fab-x svg { width: 24px; height: 24px; display: block; }
    .pw-fab-pearl { opacity: 1; }
    .pw-fab-x { opacity: 0; }
    .pw-fab.open .pw-fab-pearl { opacity: 0; transform: rotate(45deg) scale(0.7); }
    .pw-fab.open .pw-fab-x { opacity: 1; }

    .pw-hide-btn {
      position: absolute; bottom: 0; right: 24.4px;
      width: 19.2px; height: 19.2px; border-radius: 9999px;
      background: var(--pw-button-bg);
      border: 0;
      box-shadow: var(--pw-shadow-rest);
      cursor: pointer; outline: none;
      display: flex; align-items: center; justify-content: center;
      opacity: 0; pointer-events: none;
      transition: opacity 0.18s ease, transform 0.15s ease;
      z-index: 100;
      padding: 0;
    }
    .pw-hide-btn.visible { opacity: 1; pointer-events: auto; }
    .pw-hide-btn:hover {
      transform: scale(1.12);
      background: var(--pw-gradient-overlay), var(--pw-button-bg);
    }
    .pw-hide-btn svg { display: block; }
    .pw-hide-tip {
      position: absolute; bottom: calc(100% + 5px);
      left: 50%; transform: translateX(-50%);
      background: var(--pw-icon-bg); color: var(--pw-text);
      font: 500 10px/1 var(--pw-font);
      padding: 3px 8px; border-radius: 9999px;
      box-shadow: var(--pw-shadow-rest);
      white-space: nowrap; pointer-events: none;
      opacity: 0; transition: opacity 0.15s ease;
    }
    .pw-hide-btn:hover .pw-hide-tip { opacity: 1; }

    @keyframes pw-pulse {
      0%, 100% { transform: scale(1); }
      50% { transform: scale(1.06); }
    }
    .pw-pending .pw-fab {
      animation: pw-pulse 1.4s ease-in-out infinite;
    }
`;
